import React from 'react';
import { Modal, Space, Divider } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

export const Dialog = ({
  open,
  onClose,
  title,
  children,
  actions,
  width = 520,
  centered = true,
  className = '',
  ...props
}) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={
        <div style={{ margin: '0 -24px' }}>
          <div style={{ margin: '0 24px' }}>{title}</div>
          <Divider style={{ margin: '16px 0 0' }} />
        </div>
      }
      footer={
        actions ? (
          <div style={{ margin: '0 -24px' }}>
            <Divider style={{ margin: '0' }} />
            <div style={{ margin: '16px 24px 0' }}>
              <Space>{actions}</Space>
            </div>
          </div>
        ) : null
      }
      width={width}
      centered={centered}
      className={`custom-dialog ${className}`}
      closeIcon={<CloseOutlined />}
      {...props}
    >
      <div style={{ margin: '0 -24px' }}>
        <div style={{ margin: '0 24px' }}>
          <div style={{ padding: '24px 0' }}>
            {children}
          </div>
        </div>
      </div>
    </Modal>
  );
};

Dialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  actions: PropTypes.node,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  centered: PropTypes.bool,
  className: PropTypes.string,
};

export default Dialog; 